<template>
  <main
    class="home"
    data-fullscreen
    data-no-header
    v-background-image="{
      imageUrl: backgroundImageUrl,
      opacityMask: site.homepageBackgroundImageOpacityMask,
    }"
  >
    <img
      data-element="logo"
      :alt="this.$store.getters['getSite'].brandName"
      :src="logoUrl"
      :class="{ wide: wideLogo }"
    />
    <template v-if="!collectOnly">
      <h1
        data-element="heading"
        v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
      >
        Welcome to<br />Order at Table
      </h1>

      <table-number-form
        v-if="loaded"
        data-element="table-number-form"
        :tableNumber="tableNumber"
        :updateTableNumber="updateTableNumber"
        :submitTableNumber="submitTableNumber"
        :submitted="submitted"
        :showError="showError"
      />
      <div v-else data-element="loader-container">
        <generic-loader />
      </div>
    </template>
    <template v-else>
      <button
        @click="goToCollectMenu"
        class="order-now-button"
        data-element="heading"
        :style="{
          backgroundColor: themeBackground,
          ...headingFont,
          color: primaryColor,
        }"
      >
        Order now
      </button>
    </template>
    <router-link
      :to="{ name: 'terms' }"
      target="_blank"
      data-element="terms-link"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
    >
      Terms and Conditions
    </router-link>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TableNumberForm from "@/components/TableNumberForm";
import GenericLoader from "@/components/ui/GenericLoader";
export default {
  name: "homepage",
  data() {
    return {
      tableNumber: null,
      loaded: null,
      submitted: null,
      showError: null,
    };
  },
  components: {
    TableNumberForm,
    GenericLoader,
  },
  computed: {
    ...mapGetters({
      site: "getSite",
    }),
    ...mapGetters("ui", {
      themeBackground: "getBackgroundColor",
      headingFont: "getHeadingFontDetail",
      primaryColor: "getPrimaryColor",
    }),
    collectOnly() {
      return this.site && this.site.collectOnly;
    },
    logoUrl() {
      return (
        this.site &&
        this.site.homepageLogo &&
        this.site.homepageLogo.fields &&
        this.site.homepageLogo.fields.file &&
        this.site.homepageLogo.fields.file.url
      );
    },
    backgroundImageUrl() {
      return (
        this.site &&
        this.site.homepageBackgroundImage &&
        this.site.homepageBackgroundImage.fields &&
        this.site.homepageBackgroundImage.fields.file &&
        this.site.homepageBackgroundImage.fields.file.url
      );
    },
    wideLogo() {
      return this.site && this.site.widenHomepageLogo;
    },
  },
  methods: {
    ...mapActions("iOrderCore", { dispatchError: "showError" }),
    goToCollectMenu() {
      this.$store.dispatch("iOrderCore/setTableNumber", {
        tableNumber: 1,
      });
      this.$router.push({ name: "menus" });
    },
    async init() {
      if (this.$route.query.reset === "false") {
        this.$store.dispatch("checkNecessaryDataToProceed");
        this.loaded = true;
        return;
      }
      await this.$store.dispatch("clearState");
      const result = await this.$store.dispatch(
        "iOrderCore/validateVenueAndMenu"
      );
      if (!result.success) {
        console.log(result);
        return;
      }

      if (this.$route.query.tableNumber) {
        this.updateTableNumber(this.$route.query.tableNumber);
        this.submitTableNumber();
      } else {
        this.loaded = true;
      }
    },
    updateTableNumber(number) {
      this.showError = false;
      this.tableNumber = number;
    },
    submitTableNumber() {
      this.submitted = true;
      const isValidTable = this.$store.state.iOrderCore.tables.includes(
        Number(this.tableNumber)
      );
      if (!isValidTable) {
        this.showError = true;
        this.submitted = false;
        return;
      }
      this.$store.dispatch("iOrderCore/setTableNumber", {
        tableNumber: this.tableNumber,
      });
      this.$router.push({ name: "menus" });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";

.home {
  justify-content: space-around;

  .order-now-button {
    margin: auto 0 4rem;
    padding: 0.5rem 2rem;
  }
  [data-element="logo"] {
    min-width: 70px;
    width: 20%;
    margin-top: 1rem;
    &.wide {
      width: 50%;
    }
  }
  [data-element="heading"] {
    color: #fff;
    text-align: center;
    font-size: 30px;
    line-height: 1.2;
  }
  [data-element="table-number-form"] {
    width: 100%;
    margin-bottom: 10vh;
  }
  [data-element="terms-link"] {
    color: #fff;
    text-decoration: underline;
    font-size: 12px;
    -webkit-tap-highlight-color: transparent;
    margin-bottom: 10vh;
  }
  [data-element="loader-container"] {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
